export default __webpack_public_path__ + "img/ed77db94fde8a0a9efde7ee7e640a6e1.png";